import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseOperationDeletedTemplates = [
  {
    id: '-216001',
    language: Language.EN,
    subject: 'Deletion of exceptional charge or service',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_OPERATION_DELETED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Dear tenant,</p>
          <p>An exceptional charge or service has been deleted on your lease.</p>
          <p>More details here : {{pdfLink}}.</p>
          <p>Kind regards.</p>
      `,
  },
  {
    id: '-216002',
    language: Language.FR,
    subject: "Suppression d'une charge exceptionnelle ou d'un service",
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_OPERATION_DELETED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Cher/Chère locataire,</p>
          <p>Une charge exceptionnelle ou un service a été supprimé de votre bail.</p>
          <p>Plus de détails ici: {{pdfLink}}.</p>
          <p>Bien à vous.</p>
      `,
  },
  {
    id: '-216003',
    language: Language.NL,
    subject: 'Afschaffing van uitzonderlijke last of dienst',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_OPERATION_DELETED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Beste huurder,</p>
          <p>Er is een uitzonderlijke last of dienstuit uw huurovereenkomst verwijderd.</p>
          <p>Alle details hier: {{pdfLink}}.</p>
          <p>Groeten.</p>
      `,
  },
  {
    id: '-216004',
    language: Language.DE,
    subject: 'Löschung außergewöhnlicher Belastungen oder Leistungen',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_OPERATION_DELETED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Sehr geehrte/r Mieter/in,</p>
          <p>Eine außergewöhnliche Belastung oder Leistung wurde aus Ihrem Mietvertrag entfernt.</p>
          <p>Weitere Details hier: {{pdfLink}}.</p>
          <p>Mit freundlichen Grüßen.</p>
      `,
  },
];
